<template>
  <ParentPage
    class="Manuals"
    :menu="menu"
    :root-route-name="rootRouteName"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import { ManualsMenu } from '@/config'

import ParentPage from '@/components/ParentPage.vue'

export default {
  name: 'Manuals',
  components: {
    ParentPage,
  },
  data() {
    return {
      menu: ManualsMenu,
      rootRouteName: 'Manuals',
    }
  },
  computed: {
    ...mapGetters('user', [
      'canAccessManuals',
    ]),
  },
  created() {
    // Access check
    if (! this.canAccessManuals) {
      this.$router.push({
        name: 'Dashboard',
      })
    }
  },
}
</script>
